
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/context/LanguageContext';
import { getLocalizedPath } from '@/utils/languageUtils';
import { 
  FormField, FormItem, FormControl, FormMessage 
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { Link } from 'react-router-dom';

interface TermsCheckboxProps {
  form: UseFormReturn<any>;
}

const TermsCheckbox = ({ form }: TermsCheckboxProps) => {
  const { t, language } = useLanguage();

  return (
    <FormField
      control={form.control}
      name="terms"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
              className="border-white/40 bg-white/10 data-[state=checked]:bg-finance-800 data-[state=checked]:border-finance-800 data-[state=checked]:text-white"
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <p className="text-sm text-neutral-300">
              {t('auth.agreeToTerms')}{' '}
              <Link to={getLocalizedPath('/terms', language)} className="text-purple-400 hover:text-purple-300 underline">
                {t('auth.termsOfService')}
              </Link>{' '}
              {t('auth.and')}{' '}
              <Link to={getLocalizedPath('/privacy', language)} className="text-purple-400 hover:text-purple-300 underline">
                {t('auth.privacyPolicy')}
              </Link>
            </p>
          </div>
          <FormMessage className="text-red-400" />
        </FormItem>
      )}
    />
  );
};

export default TermsCheckbox;
